// Central content/config for the Contact page and booking journey.
// Presentation lives in components; the future admin area will manage
// meeting types and availability via the backend (see backend/booking.py).

export const CONTACT_SEO = {
  title: 'Contact Amden Group | Book a Business Consultation',
  description:
    'Contact Amden Group or book an appointment to discuss practical support across operations, people, growth, systems and business launch.',
  path: '/contact',
};

export const CONTACT_HERO = {
  eyebrow: 'Contact Amden',
  heading: 'Let’s talk about your business',
  copy: 'Whether you have a specific challenge, need practical support or simply want to explore where Amden could help, start the conversation here.',
  image: {
    src: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=1200&q=80',
    alt: 'A business adviser in a relaxed consultation with a business owner around a meeting table',
    width: 1200,
    height: 800,
  },
};

export const CONNECT_OPTIONS = [
  {
    id: 'enquiry',
    icon: 'mail',
    title: 'Send an Enquiry',
    copy: 'Tell us what you need support with and a member of the Amden team will follow up.',
    actionLabel: 'Complete Enquiry Form',
    target: '#contact-enquiry',
  },
  {
    id: 'booking',
    icon: 'calendar',
    title: 'Book an Appointment',
    copy: 'Choose an available time for an initial conversation about your business.',
    actionLabel: 'View Available Times',
    target: '#book-appointment',
  },
];

// Enquiry form area-of-interest options (Contact page wording).
export const ENQUIRY_AREAS = [
  { value: 'operations', label: 'Operations' },
  { value: 'people', label: 'People' },
  { value: 'growth', label: 'Growth' },
  { value: 'launch', label: 'Launch' },
  { value: 'systems', label: 'Amden Systems' },
  { value: 'ecosystem', label: 'Ecosystem Product or Partner' },
  { value: 'general', label: 'General Enquiry' },
  { value: 'other', label: 'Other' },
];

// Booking form area-of-interest options (booking wording).
export const BOOKING_AREAS = [
  { value: 'operations', label: 'Operations' },
  { value: 'people', label: 'People' },
  { value: 'growth', label: 'Growth' },
  { value: 'launch', label: 'Launch' },
  { value: 'systems', label: 'Amden Systems' },
  { value: 'ecosystem', label: 'Ecosystem' },
  { value: 'general', label: 'General Business Support' },
  { value: 'other', label: 'Other' },
];

export const CONTACT_METHODS = [
  { value: 'email', label: 'Email' },
  { value: 'phone', label: 'Phone' },
  { value: 'appointment', label: 'Appointment' },
];

export const ENQUIRY_CONSENT_WORDING =
  'I confirm Amden Group may use these details to respond to my enquiry, in line with the Privacy Policy.';

export const BOOKING_CONSENT_WORDING =
  'I confirm Amden Group may use these details to arrange and manage my appointment, in line with the Privacy Policy.';

export const CONSENT_VERSION = 'v1-2026-09';

export const WHAT_HAPPENS_NEXT = [
  {
    step: '01',
    title: 'Tell Us About Your Business',
    copy: 'Send an enquiry or select an available appointment.',
  },
  {
    step: '02',
    title: 'We Review Your Needs',
    copy: 'We’ll consider the information provided and prepare for a focused conversation.',
  },
  {
    step: '03',
    title: 'Agree the Next Step',
    copy: 'If Amden can help, we’ll outline the most practical route forward.',
  },
];

// Only questions answerable from approved information. The “is it free?”
// question is intentionally omitted until the meeting type has an approved
// price configuration (price is currently null / not configured).
export const CONTACT_FAQS = [
  {
    question: 'What happens during the initial consultation?',
    answer:
      'We’ll discuss your business, current priorities and the areas where you may need support. The purpose is to understand the situation and identify an appropriate next step.',
  },
  {
    question: 'Can I reschedule my appointment?',
    answer:
      'Yes. Use the secure rescheduling link included with your booking confirmation to select another available time.',
  },
  {
    question: 'Can I book a consultation for more than one service area?',
    answer:
      'Yes. Select the area most relevant to you and describe any additional requirements in the meeting context field.',
  },
  {
    question: 'Do you work with businesses outside Ireland?',
    answer: 'Yes — Amden works with businesses across Ireland and the UK.',
  },
  {
    question: 'Will my information be kept private?',
    answer:
      'Information submitted through the website will be handled in accordance with Amden Group’s Privacy Policy.',
  },
];

export const BOOKING_STEPS = [
  { n: 1, label: 'Meeting Type' },
  { n: 2, label: 'Date & Time' },
  { n: 3, label: 'Your Details' },
  { n: 4, label: 'Review' },
  { n: 5, label: 'Confirm' },
];
